module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrows-fullscreen-bfc57e68.svg";